import { HostAgreementContent } from '../../components/legal/HostAgreementContent';
import { LegalPage } from './LegalPage';

export function HostAgreementPage() {
  return <LegalPage doc="host-agreement">{(lang) => <HostAgreementContent lang={lang} />}</LegalPage>;
}

export default HostAgreementPage;
